import { render, staticRenderFns } from "./ElectricVehicle.vue?vue&type=template&id=5773588a&scoped=true"
import script from "./ElectricVehicle.vue?vue&type=script&lang=js"
export * from "./ElectricVehicle.vue?vue&type=script&lang=js"
import style0 from "./ElectricVehicle.vue?vue&type=style&index=0&id=5773588a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5773588a",
  null
  
)

export default component.exports